import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from './../index';

@Injectable()
export class CanActivateGuard  {

    constructor(
        protected router: Router,
        private _authorizationService: AuthorizationService
    ) { }

    canActivate(): boolean {
        if (!this._authorizationService.authenticated) {
            this.router.navigate(['/']);

            return false;
        }

        return true;
    }
}
